import { useState } from 'react';
import { api } from '../api/client';
import { useToast } from './Toast';

/**
 * Abre la foto o el PDF guardado de un gasto (21 oct 2026: el panel nuevo de
 * Gastos solo decía «Tiene la foto guardada» y Casa Sergio no podía verla).
 *
 * La URL firmada caduca en una hora, así que se pide al tocar. La pestaña se
 * abre ANTES de pedirla, en el mismo toque: Safari (iPhone) bloquea un
 * `window.open` que llega después de un `await`.
 */
export function abrirFactura(attachmentKey: string): Promise<void> {
  const ventana = window.open('', '_blank');
  return api.getReceiptUrl(attachmentKey).then(
    (url) => {
      if (ventana) {
        ventana.opener = null;
        ventana.location.href = url;
      } else {
        window.location.assign(url);
      }
    },
    (error: unknown) => {
      ventana?.close();
      throw error;
    },
  );
}

export function VerFactura({ attachmentKey, etiqueta = 'Ver factura', className = 'esc-enlace' }: {
  attachmentKey: string;
  etiqueta?: string;
  className?: string;
}): JSX.Element | null {
  const toast = useToast();
  const [abriendo, setAbriendo] = useState(false);
  // La demo no tiene fotos de verdad en S3.
  if (attachmentKey.startsWith('demo/')) return null;
  return (
    <button
      type="button"
      className={className}
      disabled={abriendo}
      onClick={(ev) => {
        ev.stopPropagation();
        setAbriendo(true);
        abrirFactura(attachmentKey)
          .catch((error: unknown) => toast.fail(error instanceof Error ? error : new Error('No se pudo abrir la factura.')))
          .finally(() => setAbriendo(false));
      }}
    >
      {abriendo ? 'Abriendo…' : etiqueta}
    </button>
  );
}
